import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import { TournamentGamesTab } from './components/tournamentGamesTab'
import { TournamentTeamsTab } from './components/tournamentTeamsTab'
import * as styles from './styles'

const TournamentDetailsPanelComponent = ({ event, loading, error, activeTab }) => {
	if (loading) {
		return (
			<div css={styles.container}>
				<div css={styles.loadingContainer}>
					<Text size={14}>Loading tournament details...</Text>
				</div>
			</div>
		)
	}

	if (error || !event) {
		return (
			<div css={styles.container}>
				<div css={styles.errorContainer}>
					<Text size={14}>Failed to load tournament details</Text>
				</div>
			</div>
		)
	}

	const tournament = event.tournament

	return (
		<div css={styles.container}>
			{/* Tab Content */}
			<div css={styles.tabContent}>
				{activeTab === 'games' && (
					<TournamentGamesTab tournamentId={tournament?.id} />
				)}
				{activeTab === 'teams' && (
					<TournamentTeamsTab tournamentId={tournament?.id} />
				)}
			</div>
		</div>
	)
}

TournamentDetailsPanelComponent.propTypes = {
	event: PropTypes.shape({
		tournament: PropTypes.shape({
			id: PropTypes.number,
			tournamentName: PropTypes.string,
			logo: PropTypes.string,
		}),
	}),
	loading: PropTypes.bool,
	error: PropTypes.string,
	activeTab: PropTypes.string.isRequired,
}

export default TournamentDetailsPanelComponent 